<div class='ContentInfo'>
  <div class='ContentInfo-header d-flex flex-row'>
    <div
      class='ContentInfo-header-title flex-grow-1 d-flex flex-column flex-sm-row align-items-center'>
      <div class='flex-grow-1'>
        <div class='Breadcrumbs'>
          <div class='Breadcrumbs-items'>
            <a [routerLink]="['/contents', 'content_group']"
            >
              <mat-icon class='Breadcrumbs-icon back'
              >keyboard_backspace
              </mat-icon
              >
            </a
            >
            <a
              [routerLink]="['/contents', 'content_group']"
              class='Breadcrumbs-item first'
            >Content Groups</a
            >
            <mat-icon class='Breadcrumbs-icon'>chevron_right</mat-icon>
            <span class='Breadcrumbs-item'>{{ contentGroupName }}</span>
          </div>
        </div>
      </div>
      <div class='ContentInfo-header-create flex-grow-1 flex-sm-grow-0'>
        <app-button
          [color]='getEditButtonProperties().color'
          [route]='getEditButtonProperties().route'
          [size]='getEditButtonProperties().size'
          [text]='getEditButtonProperties().text'></app-button>
      </div>
    </div>
  </div>
  <div class='ContentInfo-table'>
    <app-table
      *ngIf='tableReady'
      [columns]='tableColumns'
      [dataSourceParams]='tableDataSourceParams'
      [dataSource]='dataSource'
      [useRouteNavigation]='false'>
      <ng-template [appTableMobileRow] let-currentUser='currentUser' let-row='row'>
        <app-content-info-mobile-row (test)='onTest($event)' [contentGroupName]='contentGroupName'
                                     [item]='row'></app-content-info-mobile-row>
      </ng-template>
    </app-table>
  </div>
</div>
